import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { format } from 'date-fns';

import {
  StyledHeader,
  StyledHeaderText,
  StyledTradeInIcon,
  StyledText,
  StyledName,
  StyledPhone,
  StyledEmail,
  StyledTIAHContainer,
  StyledTIAHWrapper,
  StyledCustomerDetails
} from './Styles';

const propTypes = {
  tradeInCustomerInfo: PropTypes.shape({
    fullName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    invitationSource: PropTypes.string,
    createdAt: PropTypes.string
  }).isRequired,
  decodedAt: PropTypes.string
};

const defaultProps = {
  decodedAt: undefined
};

const TIAHContainer = ({ tradeInCustomerInfo, decodedAt }) => {
  if (!tradeInCustomerInfo) {
    return null;
  }

  const { fullName, phoneNumber, email } = tradeInCustomerInfo || {};

  /**
   * Returns the phone number of the TIAH customer
   * @returns {String}
   */
  const formatTIAHPhoneNumber = () => {
    if (!phoneNumber) {
      return '';
    }

    if (phoneNumber.length !== 10) {
      return phoneNumber;
    }

    const preFix = phoneNumber.slice(0, 3);
    const firstPart = phoneNumber.slice(3, 6);
    const secondPart = phoneNumber.slice(6);

    return `(${preFix}) ${firstPart}-${secondPart}`;
  };

  /**
   * Returns the date the TIAH vehicle was parked in MMMM D, YYYY format
   * @returns {String}
   */
  const getTradeInCustomerParkedDate = () => {
    if (!decodedAt) return '';
    return `${format(new Date(decodedAt), 'LLLL, d, yyyy')}`;
  };

  return (
    <StyledTIAHContainer id="TIAH-container" data-testid="tiah-customer-info">
      <StyledTIAHWrapper>
        <StyledHeader>
          <StyledTradeInIcon />
          <StyledHeaderText>
            <FormattedMessage id="vdp.pending.tiah.invitedCustomer" />
          </StyledHeaderText>
        </StyledHeader>
        <StyledText>
          {decodedAt && decodedAt.length > 0 ? (
            <>
              <FormattedMessage id="vdp.pending.tiah.createdAt.dateExists.invitedCustomer" />
              <strong>{getTradeInCustomerParkedDate()}</strong>.
            </>
          ) : (
            <FormattedMessage id="vdp.pending.tiah.createdAt.emptyDate.invitedCustomer" />
          )}
        </StyledText>
        <StyledCustomerDetails>
          <StyledName>{fullName}</StyledName>
          <StyledPhone>{formatTIAHPhoneNumber()}</StyledPhone>
          <StyledEmail>{email}</StyledEmail>
        </StyledCustomerDetails>
      </StyledTIAHWrapper>
    </StyledTIAHContainer>
  );
};
TIAHContainer.prototype = propTypes;
TIAHContainer.defaultProps = defaultProps;

export default TIAHContainer;
